export const NOURISH_MENU = [
  { label: "JAY DIETS™", href: "/diet", strong: true },
  { label: "JAY 7™ Personal Nutrition", href: "/diet/how-it-works", strong: true },
  { label: "Fat Loss", href: "/nourish/fat-loss" },
  { label: "Muscle & Performance", href: "/nourish/muscle-performance" },
  { label: "Vegetarian Nutrition", href: "/nourish/vegetarian" },
  { label: "Travel Nutrition", href: "/nourish/travel" },
  { label: "Healthy Eating", href: "/nourish/healthy-eating" },
  { label: "Recipes", href: "/nourish/recipes" },
  { label: "Nutrition Education", href: "/nourish/education" },
];

export const HERO_SEQUENCE = [
  "YOUR BODY CHANGES.",
  "YOUR LIFE CHANGES.",
  "YOUR NUTRITION SHOULD CHANGE TOO.",
  "ESTABLISH", "ADAPT", "PROGRESS", "CONSOLIDATE", "OPTIMISE", "AUTOMATE", "SUSTAIN", "OWN IT",
];

export const METHOD_STEPS = [
  { id: "discover", name: "DISCOVER", desc: "A deep personal nutrition assessment — your goals, lifestyle, food culture, health context and current eating." },
  { id: "design", name: "DESIGN", desc: "A personalised nutrition strategy built around you: calories, macros, food preferences and real life." },
  { id: "jay7", name: "JAY 7™", desc: "Your weekly personalised nutrition plan — practical meals, portions, exchanges and alternatives." },
  { id: "track", name: "TRACK", desc: "Optional food and activity tracking with the tools you already use — or none at all." },
  { id: "review", name: "REVIEW", desc: "Your progress and adherence are reviewed by a human coach, not just an algorithm." },
  { id: "adapt", name: "ADAPT", desc: "Your plan evolves. What worked stays. What didn't gets changed — with a reason." },
  { id: "progress", name: "PROGRESS", desc: "You move through your JAY phase — each phase builds on the last." },
  { id: "consolidate", name: "CONSOLIDATE", desc: "Results are made sustainable. No rebound diets, no cliff edges." },
  { id: "ownit", name: "OWN IT", desc: "You learn to manage your nutrition for life. That's the goal — independence." },
];

export const INDIAN_REGIONS = [
  ["north", "North Indian"], ["south", "South Indian"], ["east", "East Indian"],
  ["west", "West Indian"], ["north_east", "North-East Indian"],
];

export const PHASES = [
  { n: 1, name: "ESTABLISH", days: "Days 1–15", desc: "Build the foundation." },
  { n: 2, name: "ADAPT", days: "Days 16–30", desc: "Learn what works for you." },
  { n: 3, name: "PROGRESS", days: "Days 31–60", desc: "Drive measurable progress." },
  { n: 4, name: "CONSOLIDATE", days: "Days 61–90", desc: "Make results sustainable." },
  { n: 5, name: "OPTIMISE", days: "Days 91–120", desc: "Improve quality, flexibility and performance." },
  { n: 6, name: "AUTOMATE", days: "Days 121–150", desc: "Make good decisions independently." },
  { n: 7, name: "SUSTAIN", days: "Days 151–180", desc: "Create durable routines." },
  { n: 8, name: "PERFORM", days: "Days 181–210", desc: "Nutrition around performance." },
  { n: 9, name: "FLEX", days: "Days 211–240", desc: "Travel, restaurants, social events and imperfect days." },
  { n: 10, name: "MASTER", days: "Days 241–270", desc: "Strengthen nutrition knowledge and decision-making." },
  { n: 11, name: "MAINTAIN", days: "Days 271–300", desc: "Stabilise results." },
  { n: 12, name: "OWN IT", days: "Days 301–365", desc: "Nutrition independence." },
];

export const PROGRAMME_DELIVERABLES = {
  jaytrial: ["Full personal nutrition assessment", "Health conditions & lifestyle captured", "One 7-day TRIAL JAY 7 diet, built on your inputs", "Curated from the JAY Food Exchange List", "One-time only — free, no card needed"],
  jay15: ["Personal nutrition assessment", "Goal & lifestyle definition", "Initial calorie & macro framework", "JAY 7™ Week 1 personal plan", "Food exchange & portion guide", "First adjustment + baseline review"],
  jay30: ["Everything in JAY 15", "Four JAY 7™ weekly plans, adjusted weekly", "Weight & waist trends", "Meal substitutions & eating-out guidance", "Craving management & habit support", "End-of-month review"],
  jay90: ["Four-phase transformation journey", "Weekly adaptive JAY 7™ planning", "Progress & adherence tracking", "Food exchanges, substitutions & flexible eating", "Training-day / rest-day nutrition", "Travel & restaurant strategy", "4 formal phase reviews + 90-day report", "Maintenance & relapse-recovery strategy"],
  jay180: ["Everything in JAY 90", "OPTIMISE, AUTOMATE & SUSTAIN phases", "Personal food & exchange libraries", "Lifestyle optimisation resources", "Performance & recovery nutrition where relevant", "Long-term sustainability strategy"],
  jay365: ["Full-year adaptive nutrition journey", "~52 JAY 7™ cycles across 12 phases", "Personal food & exchange libraries", "Restaurant, travel & social eating toolkits", "Weight-regain prevention strategy", "Quarterly reviews + annual dashboard", "Year-end mastery review + OWN IT plan"],
  jay365pro: ["Everything in JAY 365", "Human nutritionist review", "Priority support & monthly progress reviews", "Advanced analytics", "Personalised recipe library", "Quarterly deep-dive reviews"],
};

export const TRACKERS = ["MyFitnessPal", "Cronometer", "Lose It!", "Fitbit", "Apple Health", "Google Fit", "Garmin", "Manual tracking"];

export const NOURISH_TOPICS = {
  "fat-loss": {
    title: "Fat Loss",
    kicker: "Nourish",
    intro: "Sustainable fat loss isn't about eating less of everything — it's about eating right for your body, your culture and your life.",
    points: [
      ["A deficit you can live with", "Crash diets fail because they ignore your real life. JAY builds a moderate, personalised calorie framework you can actually sustain — with the foods you already love."],
      ["Protein is your ally", "Adequate protein preserves muscle while you lose fat, keeps you full and steadies energy. Every JAY 7™ plan is built protein-first."],
      ["Adapt, don't restart", "Weight loss stalls are normal. Instead of giving up, your JAY plan adapts — portions, exchanges and meal timing evolve with your progress."],
    ],
  },
  "muscle-performance": {
    title: "Muscle & Performance",
    kicker: "Nourish",
    intro: "Building muscle and performing at your best takes more than training hard — it takes eating with intent.",
    points: [
      ["Fuel the work", "Training-day and rest-day nutrition are different. JAY plans periodise your carbohydrates and calories around how you actually train."],
      ["Protein timing made practical", "Distributing protein across your day supports recovery and growth — with Indian and international food options, not just shakes."],
      ["Recover to grow", "Sleep, hydration and recovery nutrition are built into your plan, because growth happens between sessions."],
    ],
  },
  vegetarian: {
    title: "Vegetarian Nutrition",
    kicker: "Nourish",
    intro: "You don't need meat to hit your goals. You need a plan that understands vegetarian eating — dals, paneer, legumes, soy and more.",
    points: [
      ["Complete vegetarian protein", "Smart combinations — dal + rice, paneer, soy, curd, legumes — deliver complete protein across your day."],
      ["Iron, B12 & micronutrients", "JAY plans consider common vegetarian gaps and build in food-first strategies, flagging where professional review is appropriate."],
      ["Your food culture, respected", "South Indian, North Indian, Jain, vegan-leaning — your JAY 7™ is built around how you actually eat."],
    ],
  },
  travel: {
    title: "Travel Nutrition",
    kicker: "Nourish",
    intro: "Trips, airports, hotels and client dinners don't have to derail you. Travel nutrition is a skill — and it can be learned.",
    points: [
      ["The 80/20 travel rule", "Aim for 80% aligned choices and enjoy the 20% guilt-free. Perfection isn't the goal — momentum is."],
      ["Airport & hotel playbooks", "Simple decision frameworks for buffets, room service, street food and long-haul flights."],
      ["The JAY FLEX phase", "Longer JAY programmes include a dedicated FLEX phase that trains you to eat well anywhere in the world."],
    ],
  },
  "healthy-eating": {
    title: "Healthy Eating",
    kicker: "Nourish",
    intro: "Healthy eating is not a 30-day challenge. It's a set of small, durable habits — built one week at a time.",
    points: [
      ["Build your plate", "Half vegetables, a quarter protein, a quarter smart carbs — a simple visual rule that works at home and eating out."],
      ["Hydration & rhythm", "Meal timing, hydration and sleep quietly shape hunger and cravings. JAY plans address all three."],
      ["Progress over perfection", "One imperfect meal never broke a plan. Quitting did. JAY teaches recovery, not guilt."],
    ],
  },
  recipes: {
    title: "Recipes",
    kicker: "Nourish",
    intro: "Practical, high-protein, culturally familiar recipes — built to fit your JAY 7™ plan, not fight it.",
    points: [
      ["High-protein Indian classics", "Paneer bhurji, dal makhani lightened up, tandoori chicken, egg curry — macro-friendly versions of the food you grew up with."],
      ["15-minute meals", "Fast, repeatable meals for busy weeks: overnight oats, curd bowls, stir-fries, one-pan proteins."],
      ["Personal recipe library", "JAY 180 and JAY 365 clients build a personal recipe and exchange library over their journey."],
    ],
  },
  education: {
    title: "Nutrition Education",
    kicker: "Nourish",
    intro: "The end goal of JAY DIETS is not dependence — it's understanding. Learn the why behind your plan.",
    points: [
      ["Calories & macros, demystified", "What they are, why they matter, and why obsessing over them is optional once you understand portions and exchanges."],
      ["Reading your own data", "Weight trends vs daily fluctuations, hunger signals, energy and adherence — learn to interpret your own progress."],
      ["The OWN IT philosophy", "Don't stay on a diet forever. The final JAY phases teach you to manage your nutrition independently, for life."],
    ],
  },
};
